import { inject } from '@angular/core';
import { CanMatchFn, GuardResult, MaybeAsync, Router } from '@angular/router';
import { AuthStateService } from '../data-access/services/auth-state.service';
import { secureStorage } from '../data-access/services/localstorage.service';

export const authGuard: CanMatchFn = (
  route,
  segments
): MaybeAsync<GuardResult> => {
  const router = inject(Router);
  const authStateService = inject(AuthStateService);

  const userDataRaw = secureStorage.getItem('userData');
  const userFromStorage = userDataRaw ? userDataRaw : null;
  const user = authStateService.currentUser();

  if (!user && userFromStorage) {
    authStateService.currentUser.set(userFromStorage);
    return true;
  }

  if (user) {
    return true;
  }

  return router.createUrlTree(['/']);
};
